import React from 'react'
import { LogoColor } from '../../../assets/assets'
import './new-user-on-boarding-header.css'

/**
 * @author Nestor Sandoval (based on app.action.js header)
 * @description Header component for new user onboarding view
 * @createdDate 09-11-2025
 */
const NewUserOnboardingHeader = () => {
    const logoA3 = 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/client/54/profile/logoa3_red.png'

    return (
        <div className='new-user-onboarding-header'>
            <div className='onboarding-header-logo-govo'>
                <img
                    alt='Logo de govo.digital'
                    src={LogoColor}
                    style={{ height: '32px' }}
                />
            </div>

            <div className='onboarding-header-logo-govo'>
                {/*   <img
                    alt='Logo de a3'
                    src={logoA3}
                    style={{ height: '50px' }}
                /> */}
            </div>
        </div>
    )
}

export { NewUserOnboardingHeader as default }
